module.exports = __webpack_public_path__ + "static/media/faroe-islands.a6aba568.svg";